import BusyType from 'owa-service/lib/contract/BusyType';
import getFreeBusyBarHeight from './getFreeBusyBarHeight';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { CalendarEvent } from 'mini-calendar-event-types';
import { DEFAULT_PIXELS_PER_MINUTE } from 'mini-day-view';
import { FreeBusyConstants } from 'mini-freebusy';
import { getEffectiveCharmId } from 'mini-charms/lib/utils/getEffectiveCharmId';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';
import { mergeStyles } from '@uifabric/styling';

const styles = require('../components/DayViewEventCard.scss');
const classNames = require('classnames/bind');

export function getDayViewEventCardStyles(
    item: CalendarEvent,
    hideBorder: boolean,
    hideFreeBusyBar: boolean
) {
    const { IsEffectiveAllDayEvent, IsCancelled, FreeBusyType } = item;

    const freebusyBarHeight: string = !IsEffectiveAllDayEvent
        ? getFreeBusyBarHeight(item, DEFAULT_PIXELS_PER_MINUTE)
        : '100%';

    const isCharmPresent: boolean = !isNullOrUndefined(
        getEffectiveCharmId(item.CharmId, null /* TODO: Send parent calendar charm */, false)
    );

    const freeBusyValue = IsCancelled ? (FreeBusyConstants.Free as BusyType) : FreeBusyType;

    const shouldShowEventBorder: boolean =
        !hideBorder &&
        (freeBusyValue === FreeBusyConstants.Free ||
            freeBusyValue === FreeBusyConstants.WorkingElsewhere);
    const shouldShowFreeBusyBar: boolean =
        !hideFreeBusyBar && (!IsEffectiveAllDayEvent || freeBusyValue !== FreeBusyConstants.Free);
    const isShortEvent =
        item.durationInMs() <= TimeConstants.MillisecondsIn30Mins || IsEffectiveAllDayEvent;

    const contentStyles = classNames(
        styles.itemContentWrapper,
        { [styles.showBorder]: shouldShowEventBorder },
        { [styles.freeEventBorder]: shouldShowEventBorder },
        { [styles.rightSideBorderRadius]: shouldShowFreeBusyBar }
    );

    const freeBusyBarStyles =
        !!shouldShowFreeBusyBar &&
        classNames(mergeStyles({ height: freebusyBarHeight }), styles.freeBusyBar);

    const charmStyles = classNames(
        styles.charm,
        { [styles.isShortEvent]: isShortEvent },
        { [styles.isAllDay]: IsEffectiveAllDayEvent }
    );

    const locationStyles =
        !IsEffectiveAllDayEvent &&
        classNames(
            styles.subjectAndLocation,
            isShortEvent && styles.isShortEvent // If we don't have subject but location is present location
        );

    const titleStyles = classNames(
        isShortEvent && styles.isShortEvent,
        IsCancelled && styles.isCancelled,
        styles.subjectAndLocation,
        styles.subject,
        isCharmPresent && !IsEffectiveAllDayEvent && styles.charmPresent
    );

    return { contentStyles, freeBusyBarStyles, charmStyles, locationStyles, titleStyles };
}
